import { TagValues } from 'src/easyclaim.app.libs/piexif';

const decimalToExifRational = (
	decimal: number
): [[number, number], [number, number], [number, number]] => {
	const abs = Math.abs(decimal);
	const degrees = Math.floor(abs);
	const minutesFloat = (abs - degrees) * 60;
	const minutes = Math.floor(minutesFloat);
	const seconds = Math.round((minutesFloat - minutes) * 60 * 100);

	return [
		[degrees, 1],
		[minutes, 1],
		[seconds, 100],
	];
};

export const buildGpsIfd = (position: GeolocationPosition, now: Date): Record<number, unknown> => {
	const gpsIFD: Record<number, unknown> = {};
	const { latitude, longitude, altitude, accuracy } = position.coords;

	gpsIFD[TagValues.GPSIFD.GPSVersionID] = [2, 3, 0, 0];
	gpsIFD[TagValues.GPSIFD.GPSLatitudeRef] = latitude >= 0 ? 'N' : 'S';
	gpsIFD[TagValues.GPSIFD.GPSLatitude] = decimalToExifRational(latitude);
	gpsIFD[TagValues.GPSIFD.GPSLongitudeRef] = longitude >= 0 ? 'E' : 'W';
	gpsIFD[TagValues.GPSIFD.GPSLongitude] = decimalToExifRational(longitude);

	if (altitude != null) {
		gpsIFD[TagValues.GPSIFD.GPSAltitudeRef] = altitude >= 0 ? 0 : 1;
		gpsIFD[TagValues.GPSIFD.GPSAltitude] = [Math.round(Math.abs(altitude) * 100), 100];
	}

	if (accuracy != null) {
		gpsIFD[TagValues.GPSIFD.GPSDOP] = [Math.round(accuracy * 100), 100];
	}

	const utcHours = position.timestamp
		? new Date(position.timestamp).getUTCHours()
		: now.getUTCHours();
	const utcMinutes = position.timestamp
		? new Date(position.timestamp).getUTCMinutes()
		: now.getUTCMinutes();
	const utcSeconds = position.timestamp
		? new Date(position.timestamp).getUTCSeconds()
		: now.getUTCSeconds();

	gpsIFD[TagValues.GPSIFD.GPSTimeStamp] = [
		[utcHours, 1],
		[utcMinutes, 1],
		[utcSeconds, 1],
	];

	const gpsDate = position.timestamp ? new Date(position.timestamp) : now;

	gpsIFD[TagValues.GPSIFD.GPSDateStamp] =
		`${gpsDate.getUTCFullYear()}:${String(gpsDate.getUTCMonth() + 1).padStart(2, '0')}:${String(gpsDate.getUTCDate()).padStart(2, '0')}`;

	return gpsIFD;
};
